var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-title"},[_c('div',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }